module.exports = __webpack_public_path__ + "img/Catering-Trufflemilkteadoublerow.665bf8ce.jpg";